import { submitFormData, submitJsonData, submitMultipartFormData } from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
 * @param query: {curPage,pageSize}
 * @returns Promise
 */
export function findUserApplicationPage(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/page',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
 * @param query: {curPage,pageSize}
 * @returns Promise
 */
export function findUserApplicationPageList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/pageList',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
 * @param query: {}
 * @returns Promise
 */
export function finUserApplicationList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/list',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id}
 * @param query: {}
 * @returns Promise
 */
export function getUserApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/getInfo',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {userId, applicationId, applicationUserId, applicationUserPwd, status, createTime, sort, accountId, pcOrMobile}
 * @param query: {}
 * @returns Promise
 */
export function addUserApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/add',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, userId, applicationId, applicationUserId, applicationUserPwd, status, createTime, sort, accountId, pcOrMobile, diff}
 * @param query: {}
 * @returns Promise
 */
export function editUserApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/edit',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id}
 * @param query: {}
 * @returns Promise
 */
export function deleteUserApplication(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/delete',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
 * @param query: {}
 * @returns Promise
 */
export function findUserApplicationMap(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/findMap',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, applicationUserId, applicationUserPwd}
 * @param query: {}
 * @returns Promise
 */
export function modifyUserAndPassword(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/modifyUserAndPassword',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id}
 * @param query: {}
 * @returns Promise
 */
export function checkUserAndPassword(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/checkUserAndPassword',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, status}
 * @param query: {}
 * @returns Promise
 */
export function modifyStatus(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/modifyStatus',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
 * @param query: {}
 * @returns Promise
 */
export function findByUserAndAppId(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/userApplication/findByUserAndAppId',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {key, userId, applicationId, applicationUserId, status, sysCode, pcOrMobile}
 * @param query: {}
 * @returns Promise
 */
export function realNameAuth(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/realNameAuth',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}
